import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'div[data-component-type=icon-info-mobile]',
  templateUrl: './info-mobile.component.html',
  styleUrls: ['./info-mobile.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class InfoMobileComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
